import React from "react";
import moment from "moment";


import ImagesPopup from "./ImagesPopup";
import WrappedVirtualizedTable from "./Table";
import {getIssueStatus, prepareLocation} from "../../utils/issues";
import Paper from "@material-ui/core/Paper";

import "./Issue.css";
import RadioCheckedIcon from "material-ui/svg-icons/toggle/check-box";
import RadioIcon from "material-ui/svg-icons/toggle/check-box-outline-blank";


function prepareIssueTitle(issue, delimiter = '\n') {
    const name = [];
    if (issue.checklistItemName) {
        name.push(issue.checklistItemName);
    }
    if (issue.title) {
        name.push(issue.title);
    }

    return name.join(delimiter);
}


class IssueTable extends React.PureComponent {

    limitDescription = text => {
        const SIZE = 100;
        let str = text;
        if (text && text.length > SIZE) {
            str = str.substring(0, SIZE) + "...";
        }
        return str ? <div title={text}>{str}</div> : "";
    };

    notHaveValue = value =>
        value || (
            <div
                style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    // textAlign: "center",
                    width: "100%"
                }}
            >{`-`}</div>
        );

    _prepareImageLink = data => {
        if (!data) return [];
        const {selectedProjectId} = this.props;

        let d = {...data};

        const hasFile = d.hasOwnProperty("file");
        if (hasFile) {
            d = {[data.file.id]: data.file};
        }
        const list = Object.values(d || {});
        if (list.length === 0) return [];

        return list.map(({id, uri, filestackId, type}) => {
            return {id, projectId: selectedProjectId, uri, isFile: type && type === 'document', filestackId};
        });
    };

    getIssueStatusElem = status => (
        <div className={`issue-${status ? status.toLowerCase() : ""}`}>
            {status}
        </div>
    );

    handleRowClick = (data) => {

        const {onRowClick} = this.props;

        if (onRowClick) {
            onRowClick(data);
        } else {
            console.error('onRowClick is not defined in Issue Table');
        }
    }

    render() {
        const {arrIssues, sort, reportMode, issuesForReport, selectAllCheckBox} = this.props;

        const tableColumns = [
            {
                label: "#",
                dataKey: "issueNumber",
                // disableSort: true,
                cWidth: 70,
                cellContentRenderer: ({cellData}) =>
                    this.notHaveValue(cellData)
            },
            {
                label: "Location",
                dataKey: "location",
                cWidth: 200,
                cellContentRenderer: ({cellData}) =>
                    this.notHaveValue(prepareLocation(cellData))
            },
            {
                label: "Issue description",
                dataKey: "title",
                disableSort: true,
                cWidth: 250,
                cellContentRenderer: ({cellData, rowData}) => {
                    return <span
                        style={{textAlign: 'center'}}>{this.notHaveValue(this.limitDescription(prepareIssueTitle(rowData, ' ')))}</span>
                }
            },
            {
                label: "Assign to",
                dataKey: "assignTo",
                // cWidth: 150,
                cellContentRenderer: ({cellData}) =>
                    this.notHaveValue(cellData && cellData.displayName)
            },
            {
                label: "Creation date",
                dataKey: "createdAt",
                // cWidth: 100,
                cellContentRenderer: ({cellData}) =>
                    this.notHaveValue(
                        cellData && moment(cellData).format("D/M/Y")
                    )
            },
            {
                label: "Due date",
                dataKey: "dueDate",
                // cWidth: 100,
                cellContentRenderer: ({cellData}) =>
                    this.notHaveValue(
                        cellData && moment(cellData).format("D/M/Y")
                    )
            },
            {
                label: "Status",
                dataKey: "issueState",
                // cWidth: 100,
                cellContentRenderer: ({cellData}) =>
                    this.notHaveValue(
                        this.getIssueStatusElem(getIssueStatus(cellData))
                    )
            },
            {
                label: "Images",
                dataKey: "images",
                // cWidth: 100,
                cellContentRenderer: ({cellData}) => {
                    const list = this._prepareImageLink(cellData);
                    if (list.length === 0) return this.notHaveValue(false);

                    return (
                        <ImagesPopup
                            list={this._prepareImageLink(cellData)}
                            title="Images"
                        />
                    );
                },
                disableSort: true
            }
        ];

        if (reportMode) {
            tableColumns.unshift({
                label: selectAllCheckBox(),
                dataKey: "id",
                disableSort: true,
                cWidth: 70,
                cellContentRenderer: ({ cellData }) => {
                    const idx = issuesForReport.indexOf(cellData);

                    if (idx > -1) {
                        return <RadioCheckedIcon style={{color: '#6da92e'}} />;
                    } else {
                        return <RadioIcon style={{color: '#6da92e'}}  />;
                    }
                }
            })
        }

        let vh = '80vh';
        if (window.innerHeight < 900) {
            vh = '75vh'
        }

        return (
            <Paper style={{height: reportMode ? '70vh' : vh, width: "100%"}}>
                {/*<Paper style={{ height: '80vh', width: "100%" }}>*/}
                <WrappedVirtualizedTable
                    rowCount={arrIssues.length}
                    rowGetter={({index}) => arrIssues[index]}
                    onRowClick={this.handleRowClick}
                    rowHeight={70}
                    sortBy={sort.field}
                    sort={this.activeSort}
                    sortDirection={sort.direction}
                    columns={tableColumns}
                />
            </Paper>
        )
    }
}

export default IssueTable;